import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { FullClientInterface } from '../data';
import { TestProvider } from '../providers/test.provider';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface AcceptTestSignatoriesUseCaseParams {
    client: FullClientInterface;
}

@Injectable()
export class AcceptTestSignatoriesUseCase implements UseCaseWithParam<AcceptTestSignatoriesUseCaseParams, Observable<Transaction<void>>> {
    constructor(private testProvider: TestProvider) {}

    bind(params: AcceptTestSignatoriesUseCaseParams): Observable<Transaction<void>> {
        return this.testProvider.acceptSignatories(params.client.encryptedCode);
    }
}
